import React, { useState, useEffect, useRef, useCallback, } from "react";
import { keyPress } from "../../utils/keyPress";
import { FilterWrapper } from "./FilterWrapper";
import { useDebounce } from "../../utils/useDebounce";
import { useFormContext } from "../../Form";
import { observer } from "mobx-react-lite";
import { useArticleHeaderContext } from "../..";
import { flatMap } from "lodash";
var MAXIMUM_VIEWABLE_VALUES = 20;
// ** TODOs **
// - Make the component accessibile. Doesn't work with a keyboard if there are sub categories.
export var FutureSelectFilter = observer(function (_a) {
    var onChange = _a.onChange, options = _a.options, label = _a.label, _b = _a.direction, direction = _b === void 0 ? "right" : _b, name = _a.name, _c = _a.clearLabel, clearLabel = _c === void 0 ? "All" : _c, _d = _a.isClearable, isClearable = _d === void 0 ? true : _d, id = _a.id;
    useEffect(function () {
        if (options.length > MAXIMUM_VIEWABLE_VALUES) {
            console.warn("You have more than ".concat(MAXIMUM_VIEWABLE_VALUES, " options in ").concat(label, " component, you should be using the Typeahead component"));
        }
    });
    var loading = useArticleHeaderContext().loading;
    var values = useFormContext().values;
    var _e = useState(false), isMenuVisible = _e[0], setIsMenuVisible = _e[1];
    var _f = useState(null), selected = _f[0], setSelected = _f[1];
    useEffect(function () {
        if (loading || options.length === 0)
            return;
        var value = values.get(name);
        if (value && !selected) {
            var filteredOptions = options.filter(function (option) { return option.value === value; });
            // We might have chosen a sub-option
            if (filteredOptions.length === 0) {
                filteredOptions = flatMap(options, function (option) { return option.subOptions || []; }).filter(function (subOption) { return subOption.value === value; });
            }
            if (filteredOptions.length === 0)
                return;
            var selection = {
                name: filteredOptions[0].label || "",
                value: filteredOptions[0].value || "",
            };
            setSelected(selection);
        }
    }, [values, JSON.stringify(options), name, selected, loading]);
    /* TODO useRef */
    var _g = useState(null), hoverId = _g[0], setHoverId = _g[1];
    var debouncedHoverId = useDebounce(hoverId, 100);
    var elementRef = useRef(null);
    var mouseDownHandler = useCallback(function (ev) {
        if (elementRef.current) {
            if (!elementRef.current.contains(ev.target)) {
                setIsMenuVisible(false);
            }
        }
    }, []);
    var keyFunctions = useCallback(function (event) {
        if (event.keyCode === keyPress.ESCAPE) {
            setIsMenuVisible(false);
        }
    }, [setIsMenuVisible]);
    useEffect(function () {
        /* TODO Make into a Hook */
        if (isMenuVisible) {
            document.addEventListener("keydown", keyFunctions, false);
        }
        document.addEventListener("mousedown", mouseDownHandler);
        return function () {
            if (isMenuVisible) {
                document.removeEventListener("keydown", keyFunctions, false);
            }
            document.removeEventListener("mousedown", mouseDownHandler);
        };
    }, [mouseDownHandler, isMenuVisible, keyFunctions]);
    var onSelect = function (option) {
        var selection = {
            name: option ? option.label : "",
            value: option ? option.value : "",
        };
        values.set(name, selection.value ? selection : "");
        setSelected(option ? selection : null);
        if (onChange) {
            onChange({
                name: name,
                selected: option ? selection : null,
            });
        }
        setIsMenuVisible(!isMenuVisible);
        setHoverId(null);
    };
    return (React.createElement("div", { ref: elementRef, id: id },
        React.createElement(FilterWrapper, { visible: isMenuVisible, onChange: function () { return setIsMenuVisible(!isMenuVisible); }, label: label, value: selected && selected.name },
            React.createElement("ul", { className: "affectBar--menu affectBar--menu--".concat(direction) },
                isClearable && (React.createElement("li", null,
                    React.createElement("span", { onKeyPress: function () { return onSelect(null); }, onClick: function () { return onSelect(null); }, tabIndex: 0, role: "button", "aria-disabled": loading }, clearLabel))),
                options &&
                    options.map(function (option) { return (React.createElement("li", { key: option.label, onMouseEnter: function () {
                            setHoverId(option.label);
                        }, onMouseLeave: function () {
                            setHoverId(null);
                        } },
                        React.createElement("span", { onClick: function () { return onSelect(option); }, tabIndex: 0, role: "button" }, option.label),
                        (option.label === hoverId ||
                            option.label === debouncedHoverId) &&
                            !!option.subOptions && (React.createElement("ul", { className: "affectBar--menu submenu ".concat(option.label !== hoverId ? "submenu-closing" : "") }, option.subOptions.map(function (option) { return (React.createElement("li", { key: option.label },
                            React.createElement("span", { onClick: function () { return onSelect(option); } }, option.label))); }))))); })))));
});
